// extracted by mini-css-extract-plugin
export default {"dataGroup":"DataGroup_dataGroup__0iaqb"};